<template>
    <div v-loading="loading">
        <template v-if="unionDetail.info">
            <div class="block">
                <div class="block-left">
                    <p v-text="unionDetail.info.tribeName"></p>
                    <p style="line-height: 40px">
                        （ID:
                        <input-set-value
                                width="90px"
                                size="small"
                                type="number"
                                :default-value="unionDetail.info.randomId"
                                @my-submit="updateIdFunc"/>
                        ）
                    </p>
                </div>
                <table class="block-center">
                    <tr>
                        <td>联盟创建人：</td>
                        <td v-text="`${unionDetail.info.creatorName}（${unionDetail.info.creatorId}）`"></td>
                        <td>今日业绩流水：</td>
                        <td v-text="`${numberChip(unionDetail.info.todayTribeAchievement)} 记分牌`"></td>
                        <td>金币余额</td>
                        <el-button type="primary" @click="editLmb(unionDetail.info,1)">{{ numberChip(unionDetail.info.goldCoin) }}</el-button>
                    </tr>
                    <tr>
                        <td>俱乐部数：</td>
                        <td>
                            <span v-text="`${unionDetail.info.clubMumbers} /`"></span>

                            <input-set-value
                                    size="small"
                                    type="number"
                                    :default-value="unionDetail.info.upperLimit"
                                    @my-submit="updateClubUpLimit"/>
                        </td>
                        <td>今日业绩分成：</td>
                        <td v-text="`${numberChip(unionDetail.info.todayTribeWin)} 记分牌`"></td>
                    </tr>
                    <tr>
                        <td>联盟金豆数：</td>
                        <td v-text="numberChip(unionDetail.info.tribeChip)"></td>
                        <td>联盟币余额：</td>
                         <el-button type="primary" @click="editLmb(unionDetail.info,2)">{{ numberChip(unionDetail.info.chip) }}</el-button>
                    </tr>
                    <tr>
                        <td>直属俱乐部：</td>
                        <td>
                            <router-link
                                    :to="{name:'unionClubDetail',params:{id:unionDetail.info.clubeId}}">
                                <span v-text="unionDetail.info.clubName"></span>
                            </router-link>
                        </td>
                        <td>联盟币总额：</td>
                        <td v-text="`${numberChip(unionDetail.info.chipTotal)} `"></td>
                    </tr>
                    <tr>
                        <td>联盟状态：</td>
                        <td>
                            <el-switch
                                    style="display: block"
                                    v-model="unionDetail.info.statu"
                                    @change="updateUnionConfig({unionId:unionId,status:$event})"
                                    active-color="#ff4949"
                                    inactive-color="#13ce66"
                                    active-text="关闭"
                                    inactive-text="正常"
                                    :active-value="1"
                                    :inactive-value="0"/>
                        </td>
                    </tr>
                </table>
            </div>

            <div>
                <div class="common-search">
                    <el-input v-model="searchVal" class="common-el-input" placeholder="输入俱乐部昵称或ID查询">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>

            <div class="common-table">
                <el-table
                        :data="unionDetail.clubList"
                        row-key="clubRandomId"
                        height="100%"
                        @row-click="rowClick">
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click.stop="removeClub(scope.row.id)">踢出</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="编号" type="index" align="center"/>
                    <el-table-column label="用户ID" width="150" align="center" prop="userRandomId"/>
                    <el-table-column label="用户昵称" width="150" align="center" prop="creatorName"/>
                    <el-table-column label="俱乐部昵称" width="180" align="center" prop="clubName"/>
                    <el-table-column label="俱乐部ID" align="center" prop="clubRandomId"/>
                    <el-table-column label="总人数" align="center" prop="clubMembers"/>
                    <el-table-column label="主联盟" align="center" prop="mainTribeName"/>
                    <el-table-column label="交易模式" align="center" width="100">
                        <template slot-scope="scope">{{scope.row.transType | topUpTypeName}}</template>
                    </el-table-column>
                    <el-table-column label="推广员数量" width="100" align="center" prop="promoterNumbers"/>
                    <el-table-column label="基金仓余额" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.fund|numberChip}} 金豆</template>
                    </el-table-column>
                    <el-table-column label="参数设置" align="center">
                        <template slot-scope="scope">{{scope.row.profit}}%
                            <i class="el-icon-edit-outline" @click.stop="setConfigFunc(scope.row)"></i></template>
                    </el-table-column>
                    <el-table-column label="联盟分成" align="center">
                      <template slot-scope="scope">{{scope.row.tribeProfit}}%</template>
                    </el-table-column>
                    <el-table-column label="业绩流水" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.clubAchievement|numberChip}} 记分牌</template>
                    </el-table-column>
                  <el-table-column label="对赌设置" align="center">
                    <template slot-scope="scope">{{scope.row.clubRabtio}}%
                      <i class="el-icon-edit-outline" @click.stop="setClubConfigFunc(scope.row)"></i></template>
                  </el-table-column>
                  <el-table-column label="联盟对赌比例" align="center">${numberChip(unionDetail.info.todayTribeAchievement)}
                    <template slot-scope="scope">{{numberRabtio(unionDetail.info.recordRabtio,scope.row.clubRabtio)}}%</template>
                  </el-table-column>
                  <el-table-column label="对赌仓"  align="center">
                    <template slot-scope="scope">{{scope.row.chip|numberChip}} </template>
                  </el-table-column>
                  <el-table-column label="对赌比例"  align="center">
                    <template slot-scope="scope">{{scope.row.clubRabtio}}%</template>
                  </el-table-column>
                  <el-table-column label="是否开启" align="center" >
                    <template slot-scope="scope">{{scope.row.open?'是':'否'}}</template>
                  </el-table-column>
                  <el-table-column label="是否爆仓" align="center" >
                    <template slot-scope="scope">{{scope.row.burstStatus?'是':'否'}}</template>
                  </el-table-column>
                    <el-table-column label="服务费" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.totalFree|numberChip}} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="保险" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.totalInsurance|numberChip}} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="获得JP" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.clubWinJp|numberChip}} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="总利润" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.totalWin|numberChip}} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="利润贡献" width="150" align="center">
                        <template slot-scope="scope">{{scope.row.clubTotalCommission|numberChip}} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="充值类型" align="center" width="100">
                        <template slot-scope="scope">{{scope.row.transType | topUpTypeName}}</template>
                    </el-table-column>
                    <el-table-column label="联系方式" width="150" align="center" prop="contact"/>
                    <el-table-column label="加入时间" width="150" align="center" prop="createTime"/>
                </el-table>
            </div>

            <el-pagination
                    class="common-el-pagination"
                    layout="prev,pager,next,jumper"
                    background
                    :page-size="20"
                    :pager-count="5"
                    :total="unionDetail.total"
                    :current-page="currentPage"
                    @current-change="getList($event)"/>
        </template>
        <comp-club-config ref="config" :info="configInfo" @my-submit="getList(currentPage)"/>
        <comp-record-config ref="record" :info="configInfo" @my-submit="getList(currentPage)"/>

          <!-- 修改联盟币弹框 -->
          <el-dialog :title="dialogTitle" :visible.sync="dialogFormEditLmb" width="30%">
            <el-form :model="form">
                <el-form-item label="联盟ID">:{{ form.tribeId }}</el-form-item>
                <el-form-item label="联盟名称">:{{ form.tribeName }}</el-form-item>
                <el-form-item :label="dialogTitle+'余额'">:{{ form.tribeLmb|numberChip  }}</el-form-item>
                <el-form-item label="变动后余额">:{{ form.biandongLmb|numberChip }}</el-form-item>
                <el-form-item label="类型">:
                    <el-radio-group v-model="form.type" @input="handleInput(form.editJine)">
                        <el-radio  label="1">回收</el-radio>
                        <el-radio  label="2">发放</el-radio>
                    </el-radio-group>
                    
                </el-form-item>
                <el-form-item label="金额" >
                    <el-input v-model="form.editJine" autocomplete="off"   @input="handleInput"  style="width: 240px;"></el-input>
                </el-form-item>
            </el-form>
            <!-- dialog弹框底部 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormEditLmb = false">取 消</el-button>
                <el-button type="primary" @click="submitEditLmb">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'
    import compClubConfig from '../club/compClubConfig'
    import compRecordConfig from "./compRecordConfig";

    export default {
        components: {
          compRecordConfig,
            inputSetValue,
            compClubConfig
        },
        data() {
            return {
                unionId: '',
                loading: false,
                searchVal: '',
                currentPage: 1,
                configInfo:{},
                dialogFormEditLmb:false,
                dialogTitle:"",
                editType:0,//1=金币 2=联盟币
                form: {
                    tribeId: 0,
                    tribeName: '',
                    tribeLmb: 0,
                    biandongLmb: 0,//变动后余额
                    type: "1",//修改类型：1==回收:::: 2==发放
                    editJine: '',
                    editType: '1',//操作类型：1==金币:::: 2==联盟币
                    status:1,//状态
                },
            }
        },
        computed: {
            ...mapState('union', ['unionDetail'])
        },
        created() {
            this.unionId = this.$route.params.id;
            this.getList()
        },
        methods: {
            ...mapActions('union', ['getUnionDetail', 'updateUnionConfig','updateUnionRanDomId', 'deleteClub','editTribeLmb']),
            ...mapActions('club', ['updateClubConfig']),
            // 获取联盟详情 俱乐部列表
            getList(page = 1) {
                this.loading = true;
                let params = {
                    unionId: this.unionId,
                    key: this.searchVal,
                    percent: 0,
                    page
                };

                this.currentPage = page;
                this.getUnionDetail(params).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.unionDetail.clubList.length) {
                        this.getList(this.currentPage - 1)
                    }
                });
            },
           
          // 俱乐部对赌配置
          setClubConfigFunc(row,){
            this.configInfo = row;
            this.$refs.record.show = true;
          },
          submitEditLmb(){
                // 提交联盟币修改
                this.form.editType=this.editType;
                if(this.form.editJine==0){
                    this.$msg('error',"修改金额不能为0！")
                    return;
                }
               
                this.editTribeLmb(this.form)
                    .then(res => {
                    //提交数据到vuex
                        if(res.code == 0){
                            this.$message.success(res.msg);
                            setTimeout(() => {
                                this.getList()  
                                this.dialogFormEditLmb=false;
                            }, 1000); // 1000毫秒后执行
                            
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.$message.error( err.message);
                    });
            },
          editLmb(tribeDetailFrom,editType){
                this.dialogFormEditLmb=true;
                this.editType=editType;
                debugger
                if(this.editType==1){
                    this.dialogTitle="金币";
                    this.form.tribeLmb=tribeDetailFrom.goldCoin;
                    this.form.biandongLmb=0;
                    this.form.editJine=0;
                }else if(this.editType==2){
                    this.dialogTitle="联盟币";
                    this.form.tribeLmb=tribeDetailFrom.chip;
                    this.form.biandongLmb=0;
                    this.form.editJine=0;
                }
               
                this.form.tribeId=tribeDetailFrom.randomId;
                this.form.tribeName=tribeDetailFrom.tribeName;
                this.form.type="1";
                this.form.status=tribeDetailFrom.statu;
               
            },
            handleInput(value){
                value = value.toString().replace(/[^0-9.]/g, '');
                if (value.indexOf('.') > -1) {
                    value = value.slice(0, value.indexOf('.') + 3);
                }
                this.form.editJine = Number(value);
              
                var showCoin=this.form.tribeLmb;
               
                if(this.form.type==1){//回收
                    this.form.biandongLmb=showCoin - (this.form.editJine*100);
                }else if(this.form.type==2){//增加
                    this.form.biandongLmb=(this.form.editJine*100)+showCoin;
                }

                
            },
            // 俱乐部配置
            setConfigFunc(row) {
                this.configInfo = row;
                this.$refs.config.show = true;
            },
          numberChip(val){
            return val/100;
          },
          numberRabtio(val,val1){
            return val - val1 < 0 ?0 : val - val1;
          },
            // 修改俱乐部最大上限数
            updateClubUpLimit({value, cb}) {
                if (value < this.unionDetail.info.clubMumbers) {
                    this.$message.error('不能小于当前俱乐部数');
                    return
                }
                if (value === this.unionDetail.info.upperLimit) {
                    this.$message.info('无变动');
                    return
                }
                this.updateUnionConfig({
                    unionId: this.unionId,
                    clubeUpLimit: value
                }).then(() => {
                    this.setStateUnionDetail_info({upperLimit: value});
                    this.$message.success('修改成功');
                    cb()
                })
            },
            // 修改联盟显性ID
            updateIdFunc({value, cb}) {
                if(value.length !== 7){
                    this.$message.error('您输入的ID有误，请重新输入');
                    return
                }
                this.updateUnionRanDomId({
                    tribeId: this.unionId,
                    newTribeRanDomId: value
                }).then(() => {
                    this.getList(this.currentPage);
                    this.$message.success('修改成功');
                    cb()
                })
            },
            removeClub(clubId) {
                this.$confirm('确定踢出该俱乐部吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.deleteClub({unionId: this.unionId, clubId: clubId}).then(() => {
                        this.$message.success('踢出成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {

                })

            },
            rowClick(row) {
                this.$router.push({name: 'unionClubDetail', params: {id: row.id}})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        display: flex;
        align-items: center;
        min-height: 202px;
        padding-bottom: 20px;
        &-left {
            min-width: 220px;
            padding-right: 20px;
            text-align: center;
        }
        &-center {
            td {
                height: 34px;
            }
            td:nth-of-type(2) {
                min-width: 200px;
            }
            td:first-of-type {
                text-align: right;
            }
            td:nth-of-type(3) {
                padding-left: 50px;
                text-align: right;
            }
          td:nth-of-type(5) {
            padding-left: 50px;
            text-align: right;
          }
        }
    }

    .common-input-update {
        display: inline-block;
    }
    :global(.el-icon-edit-outline) {
        color: $theme-color;
        cursor: pointer;
    }
</style>